import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import TicketDetailsScreen from '../../components/tickets/TicketDetailsScreen';

const UserTicketDetailPage = () => {
  const navigate = useNavigate();
  const { fetchUserTickets } = useApp();

  return (
    <TicketDetailsScreen
      backTo="/user/tickets"
      backLabel="Voltar aos meus tickets"
      onListUpdate={() => fetchUserTickets()}
      onResetSelection={() => navigate('/user/tickets')}
    />
  );
};

export default UserTicketDetailPage;
